import { render, staticRenderFns } from "./WorkflowStorageConfiguration.vue?vue&type=template&id=8770d170&"
import script from "./WorkflowStorageConfiguration.vue?vue&type=script&lang=js&"
export * from "./WorkflowStorageConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports